import { useEffect, useMemo } from 'react';
import { MarketIndicatorDataCombinationType, UnitOfMeasure } from '../../../../../../../Generated/Raven-Demeter';
import Dropdown from '../../../../../../Components/Form/Inputs/Dropdown';
import useLanguage from '../../../../../../Services/Language/useLanguageHook';
import styles from '../../MarketIndicatorFactorPage.module.scss';

interface IMarketFactorMathOperationDropdownProps<T> {
    upsertRequest: T & { dataCombinationType?: MarketIndicatorDataCombinationType };
    setUpsertRequest: (value: T) => void;
}

// eslint-disable-next-line @typescript-eslint/comma-dangle
const MarketFactorMathOperationDropdown = <T,>(props: IMarketFactorMathOperationDropdownProps<T>) => {
    // Application hooks.
    const [translations] = useLanguage();

    const mathOperationOptions = useMemo(
        () =>
            [
                {
                    label: translations.marketIndicatorDataCombinationType[MarketIndicatorDataCombinationType.Aggregate],
                    value: MarketIndicatorDataCombinationType.Aggregate,
                },
                {
                    label: translations.marketIndicatorDataCombinationType[MarketIndicatorDataCombinationType.Average],
                    value: MarketIndicatorDataCombinationType.Average,
                },
                {
                    label: translations.marketIndicatorDataCombinationType[MarketIndicatorDataCombinationType.Ratio],
                    value: MarketIndicatorDataCombinationType.Ratio,
                },

                {
                    label: translations.marketIndicatorDataCombinationType[MarketIndicatorDataCombinationType.Multiply],
                    value: MarketIndicatorDataCombinationType.Multiply,
                },
                {
                    label: translations.marketIndicatorDataCombinationType[MarketIndicatorDataCombinationType.Spread],
                    value: MarketIndicatorDataCombinationType.Spread,
                },
            ] as { label: string; value: MarketIndicatorDataCombinationType }[],
        [translations],
    );

    useEffect(() => {
        if (!mathOperationOptions || props.upsertRequest.dataCombinationType) {
            return;
        }

        props.setUpsertRequest({
            ...props.upsertRequest,
            dataCombinationType: mathOperationOptions[0].value,
        });
    }, [mathOperationOptions, props.upsertRequest]);

    return (
        <div className={styles.indicator_add_and_edit_row}>
            <div className={styles.indicator_add_and_edit_dropdown}>
                <Dropdown
                    value={props.upsertRequest.dataCombinationType}
                    options={mathOperationOptions}
                    handleOptionChange={(selectedMathOperation) => {
                        props.setUpsertRequest({
                            ...props.upsertRequest,
                            dataCombinationType: selectedMathOperation,
                            dataCombinationDisplayUnits: selectedMathOperation === MarketIndicatorDataCombinationType.Ratio ? UnitOfMeasure.Percent : undefined,
                        });
                    }}
                    label={translations.words.mathOperation}
                    track={{
                        eventCategory: 'MarketIndicatorFactor',
                        eventAction: 'MathOperationChanged',
                        eventValue: props.upsertRequest.dataCombinationType || '',
                    }}
                />
            </div>
        </div>
    );
};

export default MarketFactorMathOperationDropdown;
